import { styled, Box } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  'label + &': {
    marginTop: '-1.5px',
  },
}));
